import { render, staticRenderFns } from "./CardOneColumn.vue?vue&type=template&id=bc05c6d0&scoped=true"
import script from "./CardOneColumn.vue?vue&type=script&lang=js"
export * from "./CardOneColumn.vue?vue&type=script&lang=js"
import style0 from "./CardOneColumn.vue?vue&type=style&index=0&id=bc05c6d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc05c6d0",
  null
  
)

export default component.exports